import { StyleSheet } from "react-native";
import { theme } from "../../../../theme";
export const styles = StyleSheet.create({
    containerTop: {
        flexDirection: "column-reverse",
        alignItems: "center",
    },
    containerRight: {
        flexDirection: "row",
        alignItems: "center",
    },
    checkboxContainer: {
        borderColor: theme.colors.greyscale.light,
        backgroundColor: theme.colors.light.base,
        borderWidth: 1,
        borderRadius: 5,
    },
    checkboxContainerInverted: {
        borderColor: theme.colors.light.base,
    },
    checkboxContainerSelected: {
        borderColor: theme.colors.brand.base,
    },
    checkboxContainerSelectedInverted: {
        borderColor: theme.colors.light.base,
    },
    checkboxContainerError: {
        borderColor: theme.colors.negative.base,
        backgroundColor: theme.colors.negative.base,
    },
    checkboxContainerSuccess: {
        borderColor: theme.colors.positive.base,
    },
    checkboxContainerDisabled: {
        borderColor: theme.colors.greyscale.lightest,
    },
    checkbox: {
        backgroundColor: theme.colors.light.base,
        borderColor: theme.colors.light.base,
        borderWidth: 1,
        borderRadius: 5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: theme.spacing.medium,
        width: theme.spacing.medium,
    },
    checkboxHighlight: {
        backgroundColor: theme.colors.brand.base,
    },
    checkboxInverted: {
        borderColor: theme.colors.brand.base,
        backgroundColor: theme.colors.brand.base,
    },
    checkboxHighlightInverted: {
        backgroundColor: theme.colors.light.base,
    },
    labelRight: {
        paddingLeft: theme.spacing.xsmall,
        flexWrap: "wrap",
    },
    labelInverted: {
        color: "white",
    },
});
//# sourceMappingURL=InputCheckbox.styles.js.map